import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * AdminPageHeader — common header for admin sub-pages.
 *
 * Always shows a "back" button on the left so the user can return to the
 * admin dashboard without having to find a sidebar entry. The default behaviour
 * is `navigate(-1)`; a `backTo` prop can pin it to a specific route instead.
 */
const AdminPageHeader = ({ title, subtitle, icon: Icon, backTo }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) navigate(backTo);
    else if (window.history.length > 1) navigate(-1);
    else navigate('/admin');
  };

  return (
    <div className="mb-4 md:mb-6">
      <div className="p-3 md:p-4 mb-2 flex items-center gap-3">
        <button
          onClick={handleBack}
          className="shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1.5 text-sm text-white hover:bg-white/15 transition-colors"
          aria-label="Zurück"
          data-testid="admin-back-btn"
        >
          <ArrowLeft className="h-4 w-4" />
          <span className="hidden sm:inline">Zurück</span>
        </button>
        {Icon && (
          <div className="w-10 h-10 rounded flex items-center justify-center bg-white/90">
            <Icon className="h-5 w-5" style={{ color: '#C4A084' }} />
          </div>
        )}
        <div className="min-w-0">
          <h1 className="text-lg md:text-xl font-bold text-white truncate">{title}</h1>
          {subtitle && <p className="text-xs md:text-sm text-white/80 truncate">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default AdminPageHeader;
